// Source: Queensland Government, seller disclosure scheme, checked 17 October 2026.
// https://www.qld.gov.au/housing/buying-owning-home/seller-disclosure-scheme
export const SELLER_DISCLOSURE_START = "2025-08-01";
export const SELLER_DISCLOSURE_START_LABEL = "1 August 2025";